var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _vm.accessoryPrice.banner
            ? _c(
                "div",
                [
                  _c("ob1-tag", {
                    attrs: { label: _vm.accessoryPrice.banner },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.accessoryPrice.promotion
            ? _c("promo-prix-terminal", {
                staticClass: "mt-1",
                attrs: {
                  "promo-label": _vm.accessoryPrice.promotion.label,
                  "promo-end-date": _vm.accessoryPrice.promotion.endDate,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ob1-prix", {
            attrs: {
              price: _vm.accessoryPrice.price.totalPriceWithPromo,
              "initial-price": _vm.accessoryPrice.price.totalPriceWithoutPromo,
              "price-without-promo":
                _vm.accessoryPrice.price.totalPriceWithoutPromo,
            },
          }),
          _vm._v(" "),
          _vm.accessoryPrice.price.paymentInfoLabel
            ? _c("cb4x-pxf-mention", {
                attrs: {
                  "payment-info-label":
                    _vm.accessoryPrice.price.paymentInfoLabel.label,
                  "payment-info-detail":
                    _vm.accessoryPrice.price.paymentInfoLabel.detail,
                  "link-label":
                    _vm.accessoryPrice.paymentSolutionsDto.linkLabel,
                  "modal-id": "popin-pxf-4xcb",
                  "is-from-mobile-detail": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("pxf-cb4x-modal", {
            attrs: {
              "modal-id": "popin-pxf-4xcb",
              "display-cb4x": _vm.accessoryPrice.price.cb4xAvailable,
              "display-pxf": _vm.accessoryPrice.price.pxfAvailable,
            },
            scopedSlots: _vm._u(
              [
                _vm.accessoryPrice.price.cb4xAvailable
                  ? {
                      key: "cb4x-content",
                      fn: function () {
                        return [
                          _vm.fundingDetails.cb4xPopin.withFees
                            ? _c("paying-detail-cb4x-modal-content", {
                                attrs: {
                                  "modal-id": "popin-pxf-4xcb",
                                  "oney-merchant-guid":
                                    _vm.fundingDetails.cb4xPopin
                                      .oneyMerchantGuid,
                                  "oney-widget-src":
                                    _vm.fundingDetails.oneyWidgetSrc,
                                  "counter-delay":
                                    _vm.fundingDetails.counterDelay,
                                  amount:
                                    _vm.accessoryPrice.price
                                      .totalPriceWithPromo,
                                  "header-block":
                                    _vm.fundingDetails.cb4xPopin.headerBlock,
                                  "payment-example-block":
                                    _vm.fundingDetails.cb4xPopin
                                      .paymentExampleBlock,
                                  "how-to-benefit":
                                    _vm.fundingDetails.cb4xPopin.howToBenefit,
                                  cgu: _vm.fundingDetails.cb4xPopin.cgu,
                                  illustration:
                                    _vm.fundingDetails.cb4xPopin.imageZen,
                                },
                              })
                            : _vm.accessoryPrice.price
                                .spreadingPrice4xCbWithoutFees
                            ? _c("cb4x-modal-content", {
                                attrs: {
                                  "header-block":
                                    _vm.fundingDetails.cb4xPopin.headerBlock,
                                  "payment-block":
                                    _vm.fundingDetails.cb4xPopin.paymentBlock,
                                  "payment-simulation-block":
                                    _vm.fundingDetails.cb4xPopin
                                      .paymentSimulationBlock,
                                  "how-to-benefit":
                                    _vm.fundingDetails.cb4xPopin.howToBenefit,
                                  faq: _vm.fundingDetails.cb4xPopin.faqBlock,
                                  cgu: _vm.fundingDetails.cb4xPopin.cgu,
                                  "monthly-price":
                                    _vm.accessoryPrice.price
                                      .spreadingPrice4xCbWithoutFees
                                      .monthlyPrice,
                                  "first-monthly-price":
                                    _vm.accessoryPrice.price
                                      .spreadingPrice4xCbWithoutFees
                                      .firstMonthlyPrice,
                                  "one-shot-price":
                                    _vm.accessoryPrice.price
                                      .spreadingPrice4xCbWithoutFees
                                      .oneShotPrice,
                                  illustration:
                                    _vm.fundingDetails.cb4xPopin.imageZen,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.accessoryPrice.price.pxfAvailable
                  ? {
                      key: "pxf-content",
                      fn: function () {
                        return [
                          _c("pxf-modal-content", {
                            attrs: {
                              "header-block-dto":
                                _vm.fundingDetails.pxfPopin.headerBlockDto,
                              "example-pxf-data":
                                _vm.fundingDetails.pxfPopin.examplePxfData,
                              "example-pxf-tab-subtitle":
                                _vm.fundingDetails.pxfPopin
                                  .examplePxfTabSubtitle,
                              "example-pxf-tab-title":
                                _vm.fundingDetails.pxfPopin.examplePxfTabTitle,
                              "version-pxf-data":
                                _vm.accessoryPrice.price.versionPxfData,
                              "version-pxf-tab-title":
                                _vm.fundingDetails.pxfPopin.versionPxfTabTitle,
                              "pxf-legal-mentions-text":
                                _vm.fundingDetails.pxfPopin
                                  .pxfLegalMentionsText,
                              illustration:
                                _vm.fundingDetails.pxfPopin.imageZen,
                              "financing-block":
                                _vm.fundingDetails.pxfPopin.financingBlock,
                              cgu: _vm.fundingDetails.pxfPopin.cguDto,
                              "how-to-benefit-dto":
                                _vm.fundingDetails.pxfPopin.howToBenefitDto,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.accessoryPrice.showEcoParticipationDTO
        ? _c("eco-part-private-copying", {
            attrs: {
              id: _vm.accessoryPrice.ecoParticipationDTO.id + "-modal",
              "eco-part-label":
                _vm.accessoryPrice.ecoParticipationDTO.ecoParticipationLabel,
              "eco-part-link-label":
                _vm.accessoryPrice.ecoParticipationDTO
                  .ecoParticipationLinkLabel,
              "eco-part-modal":
                _vm.accessoryPrice.ecoParticipationDTO.ecoParticipationModal,
              "private-copying-label":
                _vm.accessoryPrice.ecoParticipationDTO.privateCopyingLabel,
              "private-copying-link":
                _vm.accessoryPrice.ecoParticipationDTO.privateCopyingLink,
              "private-copying-link-label":
                _vm.accessoryPrice.ecoParticipationDTO.privateCopyingLinkLabel,
              target:
                _vm.accessoryPrice.ecoParticipationDTO.ecoParticipationModal
                  .target,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGuaranteeLegalMentions
        ? _c("p", {
            staticClass: "small",
            domProps: { innerHTML: _vm._s(_vm.guaranteeLegalMentionsLabel) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }